/**
 * `fill` — replace `{token}` placeholders in a message-bundle string.
 *
 * `useTranslate` deliberately does no interpolation (its contract is a
 * pure `key → string` lookup), so copy with placeholders (`{title}`,
 * `{position}`, `{date}`, …) is filled at the call site. This helper
 * was originally local to the catalog's inline drag list and grew two
 * more copies with the US6 archive surfaces (CatalogRow's confirm title,
 * ArchiveDrawer's deleted-at meta) — extracted here as the single
 * shared implementation (review L3).
 *
 * Unknown tokens are left verbatim (`{title}` stays `{title}`) so a
 * bundle/params mismatch surfaces loudly in the UI instead of
 * rendering an empty hole.
 */
export function fill(template: string, params: Readonly<Record<string, string | number>>): string {
  // Own-property lookup, NOT `key in params`: the `in` operator walks the
  // prototype chain, so a `{toString}` / `{constructor}` token would
  // stringify the inherited Object.prototype member into the copy.
  return template.replace(/\{(\w+)\}/g, (whole, key: string) =>
    Object.hasOwn(params, key) ? String(params[key]) : whole,
  );
}
